import { render, staticRenderFns } from "./MewBanner.vue?vue&type=template&id=2872c660&scoped=true"
import script from "./MewBanner.vue?vue&type=script&lang=js"
export * from "./MewBanner.vue?vue&type=script&lang=js"
import style0 from "./MewBanner.vue?vue&type=style&index=0&id=2872c660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2872c660",
  null
  
)

export default component.exports